import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import Table from '../index';
import { selectData } from '../../../../../selectors/TileDataSelector';

const mapStateToProps = (state, ownProps) => {
  //Todo - get real events
  let data = selectData(state, ownProps);

  return {
    data
  };
};

const mapDispatchToProps = dispatch => ({});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(Table)
);
